interface IChartCheckboxes {
    checkboxes: any[];
    onChange: (value: any) => void;
}

const ChartCheckboxes = (props: IChartCheckboxes) => {
    const { checkboxes, onChange } = props;

    return (
        <fieldset className="flex flex-row gap-x-4">
            <legend className="sr-only">VS</legend>
            {checkboxes.map((checkbox: any) => (
                <div className="relative flex items-start" key={checkbox.name}>
                    <div className="flex items-center h-5">
                        <input
                            id={checkbox.name}
                            aria-describedby={checkbox.name}
                            name={checkbox.name}
                            type="checkbox"
                            className={`focus:ring-brand h-4 w-4 text-brand border-gray-300 rounded-none`}
                            defaultChecked={checkbox.current}
                            onChange={onChange}
                        />
                    </div>
                    <div className="ml-2 text-sm">
                        <label htmlFor={checkbox.name} className={`font-normal text-gray-600`}>
                            {checkbox.name}
                        </label>
                        <span id={checkbox.name} className="text-gray-500">
                            <span className="sr-only">{checkbox.name}</span>
                        </span>
                    </div>
                </div>
            ))}
        </fieldset>
    );
};

export default ChartCheckboxes;
